import { buildCloudPayQuery } from '../utils/query';
import queryString from 'query-string';

/**
 * @description Updates next period of subscription IF posible
 *
 * @param {Object} [Request options]
 * @returns {QueryConfig}
 */
export const getAllInvoicesBySubscriber = buildCloudPayQuery(
  ({ subscriberId }) => ({
    force: true,
    url: `/invoices/${subscriberId}`,
    options: {
      method: 'GET'
    }
  })
);

/**
 * @description Updates next period of subscription IF posible
 *
 * @param {Object} [Request options]
 * @returns {QueryConfig}
 */
export const getInvoicesBySubscriber = buildCloudPayQuery(
  (props) => {
    const qs = {
      size: props.globalFilter?.size || 200,
      field: props.globalFilter?.field || 'purchasedAt',
      order: props.globalFilter?.order || 'DESC',
      ...props.globalFilter,
    }
    return {
      force: true,
      url: `/invoices/list?${queryString.stringify(qs)}`,
      options: {
        method: 'GET'
      },
      transform: invoices => {
        const updatedInvoices = {
          invoices: {
            list: invoices.data,
            total: invoices.total
          }
        }
        return updatedInvoices;
      },
      update: {
        invoices: (_, invoices) => invoices
      }
    }
  }
);


export const getReceiptsBySubscriber = buildCloudPayQuery(
  (props) => ({
    force: true,
    url: `/invoices/list?size=200&field=purchasedAt&order=ASC&invoiceType=receipt`,
    options: {
      method: 'GET'
    }
  })
);

/**
 * @description Receives last invoice related to subscriber
 *
 * @param {String} subscriberId Subscriber required to show the last invoice
 * @returns {QueryConfig}
 */
export const getLastInvoiceBySubscriber = buildCloudPayQuery(() => {
  const qs = {
      size: 1,
      field: 'purchasedAt',
      order: 'DESC',
  };

  return {
      force: true,
      url: `/invoices/list?${queryString.stringify(qs)}`,
      options: {
          method: 'GET',
      },
      transform: (response) => {
          const invoice = response?.data?.[0] || null;
          return { invoice };
      },
      update: {
          invoice: (_, updatedInvoice) => updatedInvoice,
      },
  };
});